// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import {
  Box,
  Skeleton,
  SxProps,
  Typography,
  useTheme,
} from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { CoinIcon } from "../../Subscriptions";

export default function TileInfoBox({
  topText = "",
  bottomText = "",
  sx,
}: {
  topText: string | React.ReactNode;
  bottomText?: string;
  sx?: SxProps;
}) {
  return (
    <Box
      sx={{
        backgroundColor: "#F8F8F9",
        borderRadius: 8,
        flex: 1,
        fontSize: 16,
        height: "58px",
        textAlign: "center",
        padding: "3px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
      }}
    >
      <Box
        sx={[
          {
            ...sx,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <Typography
          as={Box}
          sx={{
            fontWeight: "fontWeightBold",
            whiteSpace: "nowrap",
            display: "block",
          }}
        >
          {topText}
        </Typography>
        {bottomText && (
          <Typography
            as={Box}
            sx={[
              {
                display: "block",
                fontSize: 10,
              },
              ...(Array.isArray(sx) ? sx : [sx]),
            ]}
          >
            {bottomText}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export function TileInfoBoxSimplified({
  price = "",
  isTutor = false,
  isCreditPrice = false,
  sx,
}: {
  price: string;
  isTutor: boolean;
  isCreditPrice?: boolean;
  sx?: SxProps;
}) {
  const theme = useTheme();
  const { t } = useTranslation(
    "ui-components-website\\src\\Listings\\components\\TileInfoBox"
  );

  function pricingFrequency() {
    return isTutor ? t("session") : t("class");
  }

  return (
    <Box
      flex
      sx={{
        alignItems: "center",
        flexWrap: "wrap",
        gap: 4,
        verticalAlign: "baseline",
        ...sx,
      }}
    >
      {!!isCreditPrice && (
        <Box flex sx={{ alignItems: "center", marginRight: "0.5rem" }}>
          <CoinIcon
            height={16}
            width={16}
            fillColor={theme.palette.warning.main}
            strokeColor={theme.palette.warning[700]!}
          />
        </Box>
      )}
      <Typography
        as={Box}
        variant="subtitle1"
        emphasized
        sx={{
          color: "gray950",
          display: "inline",
        }}
      >
        {price}
      </Typography>
      <Typography
        as={Box}
        variant="caption"
        sx={{
          color: "gray500",
        }}
      >
        /{pricingFrequency()}
      </Typography>
    </Box>
  );
}

export function TileInfoBoxLoading() {
  return (
    <Box
      sx={{
        flex: 1,
        height: "56px",
        textAlign: "center",
        paddingX: 7,
      }}
    >
      <Skeleton sx={{ borderRadius: 8 }} variant="rounded" height={56} />
    </Box>
  );
}
